import React from 'react';
import {Select} from "antd";
const {Option} = Select;

const SelectBox = ({
    tag,
    options,
    value,
    onChangeHandler,
    widthValue="95%",
  }) => {
    return (
      <Select id={tag}
              size="small"
              style={{width: widthValue}}
              value={value}
              onChange={onChangeHandler}
        >
        
          {options.length > 0 &&
              options.map((item, i) => {
                  return (
                    // <Option key={i} value={item.value}>
                    // {item.value==item.text?'':'['+item.value+']'} {item.text}
                    // </Option>
                    <Option key={i} value={item.value} selected={i == 0}>
                       {item.value && item.value !== item.text ? `[${item.value}] ` : ''}
                       {item.text}
                    </Option>
                  )
              })
          }
        </Select>
    );
  };

  export default SelectBox;